import React, { createContext, useContext, useEffect, useState } from "react";

// Provider que expõe a instância do editor GrapesJS + o componente selecionado
// para os painéis. O `editor` é setado pelo host quando `grapesjs.init` termina.

const EditorContext = createContext({
  editor: null,
  selected: null,
  isReady: false,
});

export const EditorProvider = ({ editor, children }) => {
  const [selected, setSelected] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!editor) return;
    const onSelect = (comp) => setSelected(comp || null);
    const onDeselect = () => setSelected(null);
    const onLoad = () => setIsReady(true);

    editor.on("component:selected", onSelect);
    editor.on("component:deselected", onDeselect);
    editor.on("load", onLoad);

    // Já pode estar carregado quando montamos.
    if (editor.getSelected()) setSelected(editor.getSelected());
    setIsReady(true);

    return () => {
      editor.off("component:selected", onSelect);
      editor.off("component:deselected", onDeselect);
      editor.off("load", onLoad);
    };
  }, [editor]);

  return (
    <EditorContext.Provider value={{ editor, selected, isReady }}>
      {children}
    </EditorContext.Provider>
  );
};

export const useEditor = () => useContext(EditorContext);
